import { PAGE_SIZE } from "./consts";

import type { NetworkPayload } from "../../../composites";

export const API = {
  fetchPaymentActivity: (
    offsetIndex: number,
    pageSize = PAGE_SIZE,
    queryString?: string,
    overrideDefaultQueryString?: string,
    disableCaching?: boolean,
  ) => {
    const DEFAULT_QUERY_STRING =
      overrideDefaultQueryString ??
      "&exclude_completed_one_time=true&state_not_in=schedule_rejected,rejected_approval,approval_expired";
    const formattedQueryString =
      (queryString ? `&${queryString}` : "") + DEFAULT_QUERY_STRING;

    return {
      url: `payment_activity?offset=${offsetIndex}&limit=${pageSize}${formattedQueryString}`,
      options: {
        method: "GET",
        disableCaching,
      },
    } satisfies NetworkPayload;
  },
  fetchTransferById: (uuid: string) => {
    return {
      url: `unverified_ach_transactions/scheduled/${uuid}/`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },
  fetchTransactionById: (uuid: string) => {
    return {
      url: `unverified_ach_transactions/${uuid}/`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },
  fetchPaymentActivityById: (
    uuid:
      | API.ScheduledACHPaymentId
      | API.ACHPaymentId
      | API.ACHReversalId
      | API.FedNowTransactionId
      | API.SwiftTransactionId
      | API.WireId,
  ) => {
    return {
      url: `payment_activity/${uuid}/`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },
  fetchFedNowById: (uuid: string) => {
    return {
      url: `fednow_transaction/${uuid}/`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },
  fetchSwiftWireById: (uuid: string) => {
    return {
      url: `swift_transactions/${uuid}/`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },
  fetchScheduledSwiftWireById: (uuid: string) => {
    return {
      url: `swift_transactions/scheduled/${uuid}/`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },
  fetchWireById: (uuid: string) => {
    return {
      url: `wires/${uuid}/`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },
  reversePayment: (payload: API.CreateACHReversal.Request) => {
    return {
      url: "unverified_ach_reversals/",
      options: {
        method: "POST",
        payload,
      },
    } satisfies NetworkPayload;
  },
  fetchACHReversalById: (uuid: string) => {
    return {
      url: `unverified_ach_reversals/${uuid}/`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },
};
